import { TOKEN_KEY } from "../constantes/localStorageKeys"
import { updateToken } from "../api/comunApi"
// Funcion que guarda el token en el localStorage
export const getTokenAndSetInLocalStorage = (token) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
    updateToken()
  }
}
